export const PERSONAL_EMAIL_NOT_ALLOWED_CODE = 'PERSONAL_EMAIL_NOT_ALLOWED';
export const BLOCKED_DOMAIN_CODE = 'BLOCKED_DOMAIN';

export const PERSONAL_EMAIL_NOT_ALLOWED_MESSAGE = 'Please use a valid business email address.';
export const BLOCKED_DOMAIN_MESSAGE = 'We are not accepting new signups at this time';
